import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme'; // Adjust path as needed
import { useTranslation } from 'react-i18next';
import { useAuth } from './services/AuthContext'; // Adjust path as needed
import { useNavigate } from 'react-router-dom';
const SignInSide = () => {
    const { t } = useTranslation();
    const { login, getUserRole } = useAuth(); // Assume getUserRole function is available in useAuth
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    // Check local storage for invitation_id on component mount
    useEffect(() => {
        const invitationId = localStorage.getItem('invitation_id');
        if (invitationId) {
            console.log('Retrieved invitation ID from local storage:', invitationId); // Confirm retrieval
        }
        // Cleanup function to prevent setting state on unmounted component
        return () => {
            setLoading(false); // Reset loading state on unmount
            setError(null); // Clear errors on unmount
        };
    }, []); // Run only once when component mounts
    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const data = new FormData(event.currentTarget);
        const email = data.get('email');
        const password = data.get('password');
        try {
            await login(email, password); // Trigger login
            const role = await getUserRole(); // Fetch user role after login
            // Redirect based on user role
            switch (role) {
                case 'buyer':
                    navigate('/buyer/dashboard');
                    break;
                case 'seller':
                    navigate('/seller/dashboard');
                    break;
                case 'checkpoint':
                    navigate('/checkpoint/dashboard');
                    break;
                case 'admin':
                    navigate('/admin/dashboard');
                    break;
                case 'platform':
                    navigate('/platform/dashboard');
                    break;
                case 'guest':
                    navigate('/guest/dashboard');
                    break;
                default:
                    navigate('/');
                    break;
            }
            // After login, you can check if there was an invitation ID stored and handle it accordingly
            const invitationId = localStorage.getItem('invitation_id');
            if (invitationId) {
                // Handle the invitation ID (e.g., navigate to a specific page)
                console.log('Found invitation ID after login:', invitationId);
                // You can navigate to a specific route or do something with the ID here
                // navigate(`/some-specific-route?invitation_id=${invitationId}`);
            }
        }
        catch (error) {
            console.error('Login error:', error.message);
            let errorMessage = t('api_error'); // Default error message
            if (error.code) {
                errorMessage = t(`firebase_auth_errors.${error.code}`) || t('api_error'); // Firebase error message
            }
            setError(errorMessage);
        }
        finally {
            setLoading(false); // Ensure loading is set to false after operation
        }
    };
    return (_jsx(ThemeProvider, { theme: theme, children: _jsxs(Container, { component: "main", maxWidth: "xs", children: [_jsx(CssBaseline, {}), _jsxs(Box, { sx: {
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }, children: [_jsx(Avatar, { sx: { m: 1, bgcolor: 'secondary.main' }, children: _jsx(LockOutlinedIcon, {}) }), _jsx(Typography, { component: "h1", variant: "h5", children: t('sign_in') }), _jsxs(Box, { component: "form", noValidate: true, onSubmit: handleSubmit, sx: { mt: 3 }, children: [_jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "email", label: t('email_address'), name: "email", autoComplete: "email", autoFocus: true }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "password", label: t('password'), type: "password", id: "password", autoComplete: "current-password" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { value: "remember", color: "primary" }), label: t('remember_me') }), error && (_jsx(Typography, { variant: "body2", color: "error", align: "center", sx: { mt: 1 }, children: error })), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, disabled: loading, children: loading ? t('loading') : t('sign_in') }), _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: true, children: _jsx(Link, { href: "/forgot-password", variant: "body2", children: t('forgot_password') }) }), _jsx(Grid, { item: true, children: _jsx(Link, { href: "/signup", variant: "body2", children: t('dont_have_account') }) })] })] })] })] }) }));
};
export default SignInSide;
